<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo.svg')"
          class="mb-3 mt-5"
          contain
          height="200"
        ></v-img>
      </v-flex>

      <v-flex mt-5 xs12>
        <h2 class="display-1 font-weight-bold mb-3">
          Votre partenaire pour
        </h2>
      </v-flex>
      <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
        <v-container grid-list-xl mb-5>
          <v-layout row wrap text-xs-center>
            <v-flex class="xs12 sm6 md6" v-for="(comp, i) in competences" :key="i">
              <v-card light>
                <v-icon class="mt-4" :color="comp.color">{{ comp.icon }} fa-fw fa-10x</v-icon>
                <h3 class="py-4">{{ comp.text }}</h3>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    competences: [
      {
        text: 'Vos sites internet',
        icon: 'fa-globe-americas',
        color: 'deep-orange darken-1',
      },
      {
        text: 'Votre communication',
        icon: 'fa-bullhorn',
        color: 'teal darken-1',
      },
      {
        text: 'Vos applications',
        icon: 'fa-mobile-alt',
        color: 'teal darken-1',
      },
      {
        text: 'Vos logiciels',
        icon: 'fa-desktop',
        color: 'deep-orange darken-1',
      },
    ],
  }),
  methods: {
  },
};
</script>

<style>

</style>
